var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgFlagFilled = function SvgFlagFilled(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.231 115.003a5.2 5.2 0 0 1-5.23-5.3v-88.17c0-1.99.65-3.31 1.96-3.98 11.77-7.29 26.16-7.29 42.5-.66 13.73 5.97 24.2 5.97 32.7.66 1.3-.66 3.26-1.32 5.22 0 1.31.67 2.62 2.66 2.62 4.64v56.35c0 1.99-1.3 3.98-3.27 4.64-13.73 4.64-28.11 4.64-43.15-1.32-11.12-5.3-20.27-5.3-28.12-1.33v29.17c0 2.65-2.61 5.3-5.23 5.3"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgFlagFilled);
export default ForwardRef;